// This funciton is in a seperate file becouse it was causing a circular dependency error
export function splitParagraphs(text) {
  return text
    .split("<p>") // split on <p> tag
    .map((paragraph) => paragraph.replace("</p>", "")) // remove </p> tag
    .filter(Boolean); // remove empty strings
}
